import { setSnackState } from '../../actions';
import { notificationDispatchUtil } from '../../utils/dispatchUtil';

export const VerificationProcesses = {
  CRYPTO_SIGNATURE_CREATION: 'CRYPTO_SIGNATURE_CREATION',
  DOCUMENT_SIGNATURE: 'DOCUMENT_SIGNATURE',
};

export const VerificationSteps = {
  WELCOME: 'WELCOME',
  SELECT_ID_TYPE: 'SELECT_ID_TYPE',
  CAPTURE_WORKFLOW: 'CAPTURE_WORKFLOW',
  SUMMARY: 'SUMMARY',
};

export const VerificationIdTypes = {
  INEIFE: 'INEIFE',
  PASSPORT: 'PASSPORT',
  OTHER: 'OTHER',
};

export const InitStateErrorWorkflow = {
  exists: false,
  message: '',
};

export const errorMessages = ({ translations }) => ({
  ID_CARD_EXPIRED: translations?.idExpiredError,
  ID_NOT_VALID_CURP_NOT_FOUND_IN_RENAPO: translations?.couldNotValidateCurp,
  ID_NOT_VALID_IN_INE_DATABASE: translations?.couldNotValidateIne,
  DEFAULT_ID_MESSAGE: translations?.tryAgainVerify,
  DEFAULT_SELFIE_MESSAGE: translations?.tryAgainSelfie,
  START_VERIFICATION: translations?.couldNotStartVerification,
  OUT_SERVICE: translations?.verificationOutOfService,
});

export const successMessages = ({ translations }) => ({
  VERIFICATION_ENDED: translations?.verificationFinished,
  ID_VALID: translations?.yourIdIsValid,
  SELFIE_VALID: translations?.yourSelfieIsValid,
});

export const snackStates = {
  successSnack: ({ type, translations }) =>
    notificationDispatchUtil.dispatch(
      setSnackState({
        open: true,
        text: successMessages({ translations })[type],
        severity: 'success',
      }),
    ),
  failureSnack: ({ type, translations }) =>
    notificationDispatchUtil.dispatch(
      setSnackState({
        open: true,
        text: errorMessages({ translations })[type],
        severity: 'error',
      }),
    ),
};
